<template>
  <b-container fluid>
    <b-row align-h="center">
      <b-col cols="12" md="4" lg="3" class="mb-3">
        <b-card>
          <template v-slot:header>
            <div class="d-flex flex-row justify-content-between">
              <div class="align-self-center">Preview</div>
              <div>
                <b-button
                  size="sm"
                  variant="success"
                  @click="createQuiz"
                  v-bind:disabled="creatingQuiz"
                  >Create Quiz</b-button
                >
              </div>
            </div>
          </template>

          <NewQuizPreview v-bind:quiz="quiz" />
        </b-card>
      </b-col>
      <b-col cols="12" md="8" lg="8" class="mb-3">
        <b-card no-body>
          <b-tabs pills card v-model="activeTab">
            <b-tab active>
              <template v-slot:title>
                Name & Date
                <b-icon-check v-if="validityNamePage" />
              </template>
              <b-card-text>
                <NewQuizPageName
                  v-bind:quiz="quiz"
                  v-model="validityNamePage"
                />
              </b-card-text>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                Rounds
                <b-icon-check v-if="validityRoundsPage" />
              </template>
              <b-card-text>
                <NewQuizPageRounds
                  v-bind:quiz="quiz"
                  v-model="validityRoundsPage"
                />
              </b-card-text>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                Links
                <b-icon-check v-if="validityLinksPage" />
              </template>
              <b-card-text>
                <NewQuizPageLinks
                  v-bind:quiz="quiz"
                  v-model="validityLinksPage"
                />
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <DialogError v-model="errorVisible">{{ errorMessage }}</DialogError>
  </b-container>
</template>

<script>
import constants from "@/assets/constants.js";
import DialogError from "@/components/DialogError";
import NewQuizPageName from "@/components/host/NewQuizPageName";
import NewQuizPageRounds from "@/components/host/NewQuizPageRounds";
import NewQuizPreview from "@/components/host/NewQuizPreview";
import NewQuizPageLinks from "@/components/host/NewQuizPageLinks";

export default {
  name: "HostDashboardNew",
  components: {
    NewQuizPageRounds,
    NewQuizPageName,
    NewQuizPreview,
    NewQuizPageLinks,
    DialogError
  },
  data() {
    return {
      quiz: this.getEmptyQuiz(),
      validityRoundsPage: false,
      validityNamePage: false,
      validityLinksPage: false,
      errorVisible: false,
      errorMessage: "",
      activeTab: 0,
      creatingQuiz: false
    };
  },
  computed: {},
  created() {
    this.$topquiz.checkSession(() => {});
    if (this.$topquiz.freshQuiz) {
      this.quiz = this.$topquiz.freshQuiz;
    }

    this.$topquiz.on(this, "hostQuiz_success", params => {
      this.updatePresets(this.quiz);
      this.quiz = this.getEmptyQuiz();
      localStorage.setItem("FreshQuiz", params[0]);
      this.$router.replace("/host");
      this.creatingQuiz = false;
    });

    this.$topquiz.on(this, "hostQuiz_error", params => {
      this.errorMessage = params[0];
      this.errorVisible = true;
      this.creatingQuiz = false;
    });
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  },
  methods: {
    updatePresets(quiz) {
      this.$store.dispatch("presetStore/setValues", [
        {
          id: constants.PRESET_ID_HOST_WEB_LINK,
          value: quiz.link_to_website
        }
      ]);
      this.$store.dispatch("presetStore/sendValues", this);
    },
    getEmptyQuiz() {
      var quiz = {
        name: "",
        rounds: [],
        public: 0,
        event_time: 0,
        link_to_stream: "",
        link_to_website: "",
        show_in_calendar: 0
      };
      return quiz;
    },
    createQuiz() {
      if (!this.validityNamePage) {
        this.errorMessage =
          "Please check if you have set a name for your quiz and that the date and time inputs are correct (set both or none).";
        this.errorVisible = true;
        this.activeTab = 0;
        return;
      }

      if (!this.validityRoundsPage) {
        this.errorMessage =
          "The is an error with one of your round definitions. There must be at least one round, and all rounds must have a name!";
        this.errorVisible = true;
        this.activeTab = 1;
        return;
      }

      if (!this.validityLinksPage) {
        this.errorMessage = "The is an error with one of your link settings.";
        this.errorVisible = true;
        this.activeTab = 2;
        return;
      }

      this.creatingQuiz = true;
      this.$topquiz.sendCommand(
        "hostQuiz",
        this.$topquiz.SessionKey,
        this.quiz
      );
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$topquiz.freshQuiz = this.quiz;
    next();
  }
};
</script>
